"use client"

import dynamic from "next/dynamic"
import { useState } from "react"
import AppIcon from "@/app/components/atomic/AppIcon"
import { Products } from "@/app/enums/Products"

const CallbackModal = dynamic(() => import("@/app/components/pageModels/healthLanding/components/CallbackModal"))

export default function LoanInsuranceCallbackLink({ className = "" }: { className?: string }) {
    const [isModalOpen, setIsModalOpen] = useState(false)

    return (
        <div className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-sm text-pale ${className}`}>
            <span className="whitespace-nowrap">Vous préférez en parler ?</span>

            <button
                type="button"
                onClick={() => setIsModalOpen(true)}
                data-test="callback-cta"
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap font-bold text-rm-blue-deep underline hover:opacity-80"
            >
                <AppIcon iconClassName="fa-phone" size="sm" />
                Être rappelé par un conseiller
            </button>

            {isModalOpen && (
                <CallbackModal
                    modalName="loan_callback_modal"
                    isOpen
                    closeModal={() => setIsModalOpen(false)}
                    productType={Products.LOAN_INSURANCE}
                    fullHeightMobile
                    modalTitle="Être rappelé par un conseiller"
                    // LOAN_INSURANCE reads the static slot list: only Products.LOAN queries available-callback-slots
                    fetchSlotsFromApi={false}
                />
            )}
        </div>
    )
}
